<template>
  <div class="main-body">
    <router-view></router-view>
    <!-- <times/> -->
  </div>
</template>

<style>
html {
  min-width: 980px;
}

html,
body,
#app,
.main-body,
.mainCont {
  height: 100%;
}

.el-table .add-porp,
.add-porp {
  color: #1D82FE !important;
  font-weight: bold;
}


.totalwrp {
  position: absolute;
  right: 50px;
}

.totalwrp span {
  margin-left: 12px;
}

body {
  margin: 0;
  background-color: #f2f3f7;
}

.el-pagination {
  margin: 16px auto;
  text-align: center;
}

.tox-tinymce-aux {
  z-index: 2700 !important;
}

a {
  text-decoration: none;
  color: #333;
}

input {
  border: none;
}

.navs .el-menu {
  border-right: none;
}

.navs .el-icon-arrow-down {
  color: aliceblue;
}

.el-dialog {
  min-width: 500px;
  max-width: 900px;
}


.el-drawer .el-table {
  padding-left: 12px;
}

.el-drawer .el-button {
  margin-left: 12px;
}

.mark-wrp {
  text-align: center;
}

.mark-wrp .el-button {
  margin: 12px 6px;
}
</style>

<script>
import times from '@/components/timeUp.vue';

  export default {
    name: 'App',
    components: {
      times
    },
  }

</script>